import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/uploadcloud.png'
import _imports_1 from '@/assets/svg/unionDel.svg'


const _withScopeId = n => (_pushScopeId("data-v-24805691"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right_box" }
const _hoisted_2 = { class: "mod_c" }
const _hoisted_3 = { class: "mod_c_title flex between" }
const _hoisted_4 = { class: "document_content" }
const _hoisted_5 = { class: "content_left" }
const _hoisted_6 = { class: "flex between top" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "picture_btn" }
const _hoisted_9 = { class: "document_table" }
const _hoisted_10 = { class: "flex between" }
const _hoisted_11 = { class: "table_head" }
const _hoisted_12 = { class: "head" }
const _hoisted_13 = { class: "portal_volume flex" }
const _hoisted_14 = { class: "opacity" }
const _hoisted_15 = { class: "time" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "mod_pagin establish_pagation" }
const _hoisted_19 = { class: "content_right" }
const _hoisted_20 = { class: "echart" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "span_color padding" }, "文档占用空间:", -1))
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "flex between span_color padding" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总资产:", -1))
const _hoisted_25 = { class: "used_resource padding" }
const _hoisted_26 = { class: "apply_resource flex between" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "文档使用资源:", -1))
const _hoisted_28 = { class: "flex between span_color" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "剩余资源:", -1))
const _hoisted_30 = { class: "purchase_btn" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title upgrade" }, "升级", -1))
const _hoisted_32 = { class: "edit_message" }
const _hoisted_33 = { class: "document_classficate" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "star" }, "*", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "document_head" }, "文件分类:", -1))
const _hoisted_36 = { class: "document_upload" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant_upload_text" }, "点击上传,或者将文件拖拽到此处", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant_upload_text" }, "支持类型:pdf ppt doc execl txt zip", -1))
const _hoisted_40 = { class: "more_file" }
const _hoisted_41 = { class: "file" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "moreFile" }, "支持多文件格式", -1))
const _hoisted_43 = { class: "contract_content" }
const _hoisted_44 = { class: "contract_prgress flex between" }
const _hoisted_45 = { class: "volume" }
const _hoisted_46 = { class: "progress" }
const _hoisted_47 = { class: "handle" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "preview_prompt" }
const _hoisted_50 = { class: "prompt_img" }
const _hoisted_51 = ["src"]

import { computed, onMounted, reactive, ref, unref, watch } from 'vue';
import { Input, DatePicker, Modal, Pagination, Table, message, Progress, Alert } from 'ant-design-vue';
import { SearchOutlined, RightOutlined } from '@ant-design/icons-vue';
import { ColumnProps } from 'ant-design-vue/es/table/interface';
import moment from 'moment';
import Crumb from '@/components/Crumb.vue';
import * as echarts from 'echarts';
import CDelModal from '@/components/CDelModal.vue';
import CMenu from '../components/CLeftMenu.vue';
import http from '@/api/conentCenter/communal';
import CAddCategoryVue from '../components/CAddCategory.vue';
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import { getToken } from '@/plugins/cookie';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import CMove from '../components/CMoveSort.vue';
import { moveSort, createSort, sortList } from './sortFunction';
import { useUpload } from './multipleUpload';
import emitter from '@/utils/mitt';
import { ElUpload } from 'element-plus';
type Key = ColumnProps['key'];
interface DataType {
  key: number;
  id: number;
  name: string;
  format: string;
  category: string;
  sort_name: string;
}
interface RefererCharts {
  value: number;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'documentCategorize',
  setup(__props) {

const route = useRoute();
const gatewayId = route.params.gatewayId;
const store = useStore();
const aInputSearch = Input.Search;
const { RangePicker } = DatePicker;
const aRangePicker = RangePicker;
const aPagination = Pagination;
const aProgress = Progress;
// const aUploadDragger = Upload.Dragger;
const aTable = Table;
const aModal = Modal;
const aAlert = Alert;
const showLoading = ref<boolean>(false);
const checked_all = ref(false);
const confirm = ref(false);
const push_type = ref(0);
const modalVisible = ref(false);
const mediaRef = ref();
const { fileList, viewFileList, clearFile, beforeUpload, handleChange } = useUpload({ type: 2 });
const ranges: any = {
  今天: [moment().startOf('day'), moment().endOf('day')],
  最近一周: [moment().startOf('day').subtract(1, 'weeks'), moment()],
  最近一月: [moment().startOf('day').subtract(1, 'months'), moment()],
  最近三月: [moment().startOf('day').subtract(3, 'months'), moment()],
};

const datafol = ref<DataType[]>([]);

const columns = [
  {
    title: '标题名称',
    dataIndex: 'name',
    width: '230px',
    align: 'center',
    ellipsis: true,
    slots: {
      customRender: 'name',
    },
  },
  {
    title: '格式',
    dataIndex: 'format',
    width: '60px',
  },
  {
    title: '分类',
    dataIndex: 'sort_name',
    width: '100px',
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'portalHandle',
    width: '100px',
    align: 'right',
    slots: {
      customRender: 'portalHandle',
    },
  },
];

//弹框删除按钮
const openDelModat = () => {
  modalVisible.value = false;
  selectedRowKeys.value = [];
  checked_all.value = false;
};
//弹框确认按钮
const removeLiveData = () => {
  createStatus.value = 0;
  let delPortal = {
    id: selectedRowKeys.value.join(','),
    type: 2,
    portal_id: gatewayId,
  };
  http
    .getDelPortalFile({ params: delPortal })
    .then((res) => {
      message.success(res.data.message);
      getFileList();
      createStatus.value = 4;
      checked_all.value = false;
      selectedRowKeys.value = [];
      modalVisible.value = false;
      emitSelectedRowKeys();
    })
    .catch((res: any) => {
      message.error(res.data.error);
      modalVisible.value = false;
    });
};
//删除按钮
const openDelModal = () => {
  // id重复，清空数组
  let data: any = [];
  datafol.value.map((res) => {
    data.push(res.id);
  });
  modalVisible.value = true;
};
// 全选
const setSelectAll = () => {
  if (checked_all.value) {
    let data: any = [];
    datafol.value.map((res) => {
      data.push(res.id);
    });
    onSelectChange([...data]);
  } else {
    onSelectChange([]);
  }
};
//表格删除按钮
const tabDel = (record: any) => {
  // 清空id
  selectedRowKeys.value = [];
  // 获取id
  selectedRowKeys.value.push(record.id);
  modalVisible.value = true;
};

const selectedRowKeys = ref<Key[]>([]);
selectedRowKeys.value = [];
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
  checked_all.value = selectedRowKeys.value.length == datafol.value.length ? true : false;
  emitSelectedRowKeys();
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});

/**
 *  上传文件
 * */

const uploadEvent = () => {
  confirm.value = true;
  getSortList();
};

const saveAddFile = () => {
  viewFileList.value.forEach((item) => {
    addPortalFile(item);
  });
  clearFile();
  setTimeout(() => {
    confirm.value = false;
    createStatus.value = 4;
    getFileList();
    push_type.value = sortId.value;
  }, 500);
};

// 添加上传文件
const addPortalFile = async (file: any) => {
  let params = {
    sort_id: push_type.value,
    name: file.name,
    type: 2,
    size: file.size,
    file_link: file.url,
    format: file.format,
    portal_id: gatewayId,
  };
  createStatus.value = 0;
  await http.add_portal_file(params).then(() => {
    viewFileList.value = [];
  });
};

const delViewFileList = (index: number) => {
  viewFileList.value.splice(index, 1);
};

// 根据header项过滤菜单
const selectedKeys = ref<string[]>([]);
/**
 * init 初始化
 * 路由进入前处理底部栏
 **/
store.commit('home/setCustomFooter', true);
const customData = computed(() => store.state.home.customData);
const customFootStyle = computed(() => store.state.home.customFootStyle);
onBeforeRouteUpdate((to) => {
  selectedKeys.value = [to.path];
});
onBeforeRouteLeave(() => {
  store.commit('home/setCustomFooter', false);
});

// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 1, // 总数
  options: ['12', '24', '36', '48', '60'], // 选项
});

const operation = reactive({
  use_time_filter: ref([]), // 使用记录时间筛选
  keyword: '',
});

// 获取文档列表
const getFileList = () => {
  checked_all.value = false;
  showLoading.value = true;
  let filelist = {
    type: 2,
    keyword: operation.keyword,
    start_at: operation.use_time_filter[0] ? new Date(operation.use_time_filter[0]) : operation.use_time_filter[0],
    end_at: operation.use_time_filter[1] ? new Date(operation.use_time_filter[1]) : operation.use_time_filter[1],
    sort_id: sortId.value,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
    portal_id: gatewayId,
  };
  http
    .getFileList({ params: filelist })
    .then((res) => {
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
      const degree = res.data.data;
      datafol.value = [...degree.data];
      showLoading.value = false;
    })
    .catch(() => {
      showLoading.value = false;
    });
  selectedRowKeys.value = []; //移动数据到另一个分类里如果处于选中状态，就清空id。
};

// 预览
const msgInfoRef = ref();
const datas = ref();
const previews = ref<boolean>(false);
const imageUrls = ref();
const handPreview = () => {
  previews.value = false;
};
const previewsImg = (record: any) => {
  imageUrls.value = record.file_link;
  window.location.href = record.file_link; //预览下载
};

const moveSortId = ref();
const getMoveSortId = (data: any) => {
  moveSortId.value = data;
};

/** */

/** 获取分类列表 */
const { sortListArr, getSortList } = sortList({
  type: 4,
  gatewayId: gatewayId,
});

// 分类id
const sortId = ref();
const sortInfo = ref();
const getSortInfo = (data: any) => {
  sortId.value = data.id;
  push_type.value = data.id;
  sortInfo.value = data;
  operation.use_time_filter = [];
  getFileList();
};
/**
 * 移动分类
 */
const emitSelectedRowKeys = () => {
  emitter.emit('selectedRowKeys', selectedRowKeys.value);
};

const childRef = ref();
const { isMove, moveStatus, createMove } = moveSort({
  type: 4,
  gatewayId: gatewayId,
});
watch(
  () => moveStatus.value,
  () => {
    moveStatus.value == 4 && getFileList();
  }
);

const moveCategory = () => {
  isMove.value = true;
};
const closeMove = () => {
  isMove.value = !isMove.value;
};

/** */

/**
 * 添加分类
 */
const { isVisible, createStatus, getCreate } = createSort({
  gatewayId: gatewayId,
});

const addCategory = () => {
  isVisible.value = true;
};
const isopenDelModal = () => {
  isVisible.value = !isVisible.value;
};
/** */

// 获取文件占比
const totalRecource = ref('');
const remainingResources = ref('');
const percentage = ref('');
const fileUseSize = ref('');
const portalFileResources = () => {
  let resource = {
    type: 2,
  };
  http.getPortalFileResources({ params: resource }).then((res) => {
    const target = res.data.data;
    totalRecource.value = target.total_resources;
    remainingResources.value = target.remaining_resources;
    percentage.value = target.percentage;
    fileUseSize.value = target.file_use_size;

    refererData.value.push({
      name: '文档',
      value: res.data.data.percentage,
    });
    const chartDom: HTMLElement = document.getElementById(main.value) as HTMLElement;
    refererCharts = echarts.init(chartDom);
    referChartsOption(refererData.value);
  });
};
portalFileResources();
const main = ref(`main${Date.now() + Math.random()}`);
const refererData = ref<RefererCharts[]>([]);
let refererCharts: echarts.ECharts;
const referChartsOption = (sourceData: RefererCharts[]) =>
  refererCharts.setOption({
    tooltip: {
      trigger: 'item',
      confine: true,
      formatter: '{b}：{c}%',
    },
    //修改图例
    legend: {
      type: 'scroll',
      orient: 'vertical',
      icon: 'circle',
      right: 0,
      top: 36,
    },
    toolbox: {
      show: true,
    },

    series: [
      {
        type: 'pie',
        radius: ['40%', '50%'],
        center: ['40%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          color: '#FF9337',
        },
        label: {
          //中间数值%
          show: true,
          position: 'center',
          formatter: '{c}%',
        },
        emphasis: {
          label: {
            show: false,
            fontSize: '14',
            fontWeight: 'bold',
          },
        },
        //添加指示线指示文字
        labelLine: {
          // show: false,
          show: false,
          length: 15,
          length2: 15,
          lineStyle: {
            color: '#333',
          },
        },
        data: sourceData,
      },
    ],
  });
onMounted(() => {
  window.onresize = function () {
    refererCharts.resize();
  };
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", {
      class: "box",
      ref_key: "msgInfoRef",
      ref: msgInfoRef
    }, [
      _createVNode(CMenu, {
        "data-source": { menuType: 4, createSort: _unref(createStatus), moveSort: _unref(moveStatus) },
        onSortInfo: getSortInfo
      }, null, 8, ["data-source"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "mod_wrap mod_set_wrap",
          ref_key: "mediaRef",
          ref: mediaRef
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createTextVNode(" 文档分类 / "),
                _withDirectives(_createElementVNode("span", { class: "sub_title" }, _toDisplayString(sortInfo.value?.name) + "(" + _toDisplayString(sortInfo.value?.count) + ")", 513), [
                  [_vShow, sortInfo.value?.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_a_button, { onClick: moveCategory }, {
                  default: _withCtx(() => [
                    _createTextVNode("移至分类"),
                    _createVNode(_unref(RightOutlined))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  class: "mod_btn_primary actived",
                  onClick: addCategory
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加分类")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(aRangePicker), {
                      value: operation.use_time_filter,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((operation.use_time_filter) = $event)),
                      ranges: ranges,
                      "show-time": { format: 'HH:mm' },
                      format: "YYYY-MM-DD HH:mm",
                      class: "mod_range_picker",
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (getFileList())),
                      onOk: _cache[2] || (_cache[2] = ($event: any) => (getFileList()))
                    }, {
                      suffixIcon: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_unref(aInputSearch), {
                      value: operation.keyword,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((operation.keyword) = $event)),
                      onSearch: _cache[4] || (_cache[4] = ($event: any) => (getFileList())),
                      class: "mod_range_picker_search",
                      placeholder: "请输入标题名称"
                    }, {
                      enterButton: _withCtx(() => [
                        _createVNode(_unref(SearchOutlined))
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "establish_button",
                      onClick: uploadEvent
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("上传")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_checkbox, {
                      class: "select",
                      checked: checked_all.value,
                      "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((checked_all).value = $event)),
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (setSelectAll()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("全选")
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _createVNode(_component_a_button, {
                      type: "link",
                      danger: "",
                      class: "picture_del",
                      disabled: selectedRowKeys.value.length == 0,
                      onClick: openDelModal
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          class: "mod_btn_icon",
                          "icon-class": "del"
                        })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 删除 ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(aTable), {
                    loading: showLoading.value,
                    "row-selection": _unref(rowSelection),
                    columns: columns,
                    "data-source": datafol.value,
                    pagination: false,
                    class: "liveList_w",
                    rowKey: 
                    (res) => {
                      return res.id;
                    }
                  
                  }, {
                    name: _withCtx(({ record }) => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_svg_icon, {
                          class: "avatar",
                          "icon-class": 
                          record.format.indexOf('ppt') != -1
                            ? 'suffix_ppt'
                            : record.format.indexOf('doc') != -1
                            ? 'suffix_doc'
                            : record.format.indexOf('pdf') != -1
                            ? 'suffix_pdf'
                            : record.format.indexOf('xls') != -1
                            ? 'suffix_xls'
                            : record.format.indexOf('zip') != -1
                            ? 'suffix_zip'
                            : record.format.indexOf('txt') != -1
                            ? 'suffix_txt'
                            : 'suffix_other'
                        
                        }, null, 8, ["icon-class"]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(record.name), 1),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(record.size) + "   ", 1),
                            _createElementVNode("div", _hoisted_15, "   " + _toDisplayString(record.created_at) + "  10:20", 1)
                          ])
                        ]),
                        _createTextVNode(" " + _toDisplayString(record.text), 1)
                      ])
                    ]),
                    portalHandle: _withCtx(({ record }) => [
                      _createElementVNode("a", {
                        class: "liveList_icon",
                        centered: "",
                        onClick: ($event: any) => (previewsImg(record))
                      }, [
                        _createVNode(_component_svg_icon, {
                          class: "liveList_out",
                          "icon-class": "download"
                        }),
                        _createTextVNode(" " + _toDisplayString(record.text), 1)
                      ], 8, _hoisted_16),
                      _createElementVNode("a", {
                        class: "liveList_icon",
                        centered: "",
                        onClick: ($event: any) => (tabDel(record))
                      }, [
                        _createVNode(_component_svg_icon, {
                          "icon-class": "document",
                          class: "liveList_out"
                        }),
                        _createTextVNode(" " + _toDisplayString(record.text), 1)
                      ], 8, _hoisted_17)
                    ]),
                    _: 1
                  }, 8, ["loading", "row-selection", "data-source", "rowKey"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  (datafol.value.length !== 0)
                    ? (_openBlock(), _createBlock(_unref(aPagination), {
                        key: 0,
                        "show-quick-jumper": "",
                        total: pageConfig.totalSize,
                        current: pageConfig.current,
                        "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((pageConfig.current) = $event)),
                        "page-size": pageConfig.pageSize,
                        "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((pageConfig.pageSize) = $event)),
                        pageSizeOptions: pageConfig.options,
                        "show-less-items": "",
                        "show-size-changer": "",
                        onChange: getFileList,
                        onShowSizeChange: getFileList
                      }, null, 8, ["total", "current", "page-size", "pageSizeOptions"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", {
                    id: main.value,
                    class: "main mod_c_tbody"
                  }, null, 8, _hoisted_22),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", null, _toDisplayString(totalRecource.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", null, _toDisplayString(fileUseSize.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", null, _toDisplayString(remainingResources.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_a_button, { class: "mod_btn_primary actived btn_upgrade" }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        class: "mod_nav_btn_icon",
                        "icon-class": "purchase"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: { path: `/wallet/resource`, query: { pageIndex: 4 } },
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createVNode(_unref(aModal), {
              visible: confirm.value,
              "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((confirm).value = $event)),
              title: "文件上传",
              centered: "",
              onOk: saveAddFile,
              onCancel: _cache[11] || (_cache[11] = ($event: any) => ((viewFileList.value = []), _unref(clearFile)())),
              okText: "保存"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_unref(aAlert), {
                    type: "warning",
                    class: "warn_content",
                    message: "上传过程中请勿刷新页面;",
                    banner: "",
                    closable: ""
                  }),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _hoisted_35,
                    _createVNode(_component_a_select, {
                      class: "document_select",
                      value: push_type.value,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((push_type).value = $event)),
                      placeholder: "请选择分类"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortListArr), (i) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: i.id,
                            value: i.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(i.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_unref(ElUpload), {
                      name: "file",
                      headers: { token: _unref(getToken)() },
                      action: "/api/v2/portal/upload_portal_file",
                      accept: ".pdf,.ppt,.pptx,.doc,.docx,.txt,.excel,.xlx,.xlsx,.zip,.svg,.png,.jpg,.jpeg",
                      drag: "",
                      multiple: "",
                      "show-file-list": false,
                      "file-list": _unref(fileList),
                      "before-upload": _unref(beforeUpload),
                      "http-request": _unref(handleChange)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_37,
                        _hoisted_38,
                        _hoisted_39
                      ]),
                      _: 1
                    }, 8, ["headers", "file-list", "before-upload", "http-request"])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, "文件:  共" + _toDisplayString(_unref(viewFileList).length) + "个", 1),
                    _hoisted_42
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewFileList), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "sales_contract",
                      key: index
                    }, [
                      _createVNode(_component_svg_icon, {
                        class: "icon",
                        "icon-class": 
                    item.format.indexOf('ppt') != -1
                      ? 'suffix_ppt'
                      : item.format.indexOf('doc') != -1
                      ? 'suffix_doc'
                      : item.format.indexOf('pdf') != -1
                      ? 'suffix_pdf'
                      : item.format.indexOf('xls') != -1
                      ? 'suffix_xls'
                      : item.format.indexOf('zip') != -1
                      ? 'suffix_zip'
                      : item.format.indexOf('txt') != -1
                      ? 'suffix_txt'
                      : 'suffix_other'
                  
                      }, null, 8, ["icon-class"]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", null, _toDisplayString(item.name), 1),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, _toDisplayString((item.size / 1024 / 1024).toFixed(2)) + "MB", 1),
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_unref(aProgress), {
                              percent: item.percentage
                            }, null, 8, ["percent"])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("img", {
                              class: "liveList_outs cursor",
                              src: _imports_1,
                              onClick: ($event: any) => (delViewFileList(index))
                            }, null, 8, _hoisted_48)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(CDelModal, {
              visible: modalVisible.value,
              centered: "",
              close: openDelModat,
              ok: removeLiveData
            }, null, 8, ["visible"]),
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_unref(aModal), {
                visible: previews.value,
                "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((previews).value = $event)),
                title: datas.value,
                centered: true,
                onOk: handPreview,
                width: 800,
                footer: null,
                getContainer: () => msgInfoRef.value
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_50, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageUrls.value, (img, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        class: "img",
                        key: index,
                        src: img
                      }, null, 8, _hoisted_51))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["visible", "title", "getContainer"])
            ]),
            _createVNode(CAddCategoryVue, {
              visible: _unref(isVisible),
              close: isopenDelModal,
              ok: _unref(getCreate),
              centered: ""
            }, null, 8, ["visible", "ok"]),
            _createVNode(CMove, {
              ref_key: "childRef",
              ref: childRef,
              "data-source": { menuType: 4, moveStatus: _unref(moveStatus) },
              visible: _unref(isMove),
              close: closeMove,
              ok: _unref(createMove),
              onMoveSortId: getMoveSortId,
              centered: "",
              onSortInfo: getSortInfo
            }, null, 8, ["data-source", "visible", "ok"])
          ])
        ], 512),
        _withDirectives(_createElementVNode("div", { class: "mod_footer" }, _toDisplayString(_unref(customData).copyright), 513), [
          [_vShow, _unref(customFootStyle)]
        ])
      ])
    ], 512)
  ], 64))
}
}

})